import {AXIOS} from "@/http-common";
import BaudarlehenInitialisierungsTO from "@/types/BaudarlehenInitialisierungsTO";
import BaudarlehenVergleichsergebnisTO from "@/types/BaudarlehenVergleichsergebnisTO";
import BaudarlehenAnfrageTO from "@/types/BaudarlehenAnfrageTO";
import BaudarlehenErgebnisTO from "@/types/BaudarlehenErgebnisTO";

enum url {
    BERECHNUNG = "berechnung",
    INITIALISIERUNG = "initialisierung",
    VERGLEICHSMODELLE = "vergleichsmodelle"
}

export const baudarlehenInitialisierung = async (rechnerLib: string): Promise<BaudarlehenInitialisierungsTO> =>
    await AXIOS.post(url.INITIALISIERUNG, {
        rechnerLib: rechnerLib
    }).then((response: { data: BaudarlehenInitialisierungsTO; }) => response.data);

export const baudarlehenBerechnung = async (anfrage: BaudarlehenAnfrageTO): Promise<BaudarlehenErgebnisTO> =>
    await AXIOS.post(url.BERECHNUNG, anfrage).then((response: { data: BaudarlehenErgebnisTO; }) => response.data);

export const baudarlehenVergleichsmodelle = async (anfrage: BaudarlehenAnfrageTO): Promise<BaudarlehenVergleichsergebnisTO> =>
    await AXIOS.post(url.VERGLEICHSMODELLE, anfrage).then(response => response.data);
